import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

const IMPERSONATOR_EMAIL_CLAIM = 'https://lineupteams.com/impersonator_email';

@Component({
  selector: 'app-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.scss'],
  standalone: false
})
export class PortalHomeComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  impersonatedBy: string | null = null;
  impersonatedPersonName: string | null = null;

  private _mobileQueryListener: () => void;
  private _oidcSubscription: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private oidcSecurityService: OidcSecurityService,
    private appConfigService: AppConfigService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 959px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }
  isInTestMode: boolean = false;
  ngOnInit(): void {
    this._oidcSubscription = this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.impersonatedBy = userData?.[IMPERSONATOR_EMAIL_CLAIM] ?? null;
      if (this.impersonatedBy) {
        this.impersonatedPersonName =
          `${userData?.given_name ?? ''} ${userData?.family_name ?? ''}`.trim() || null;
      }
      if (userData?.sub) {
        pendo.initialize({
          visitor: {
            id: userData.sub,
            lineup_person_id: userData.sub,
            name: `${userData.given_name ?? ''} ${userData.family_name ?? ''}`.trim() || null,
            email: userData.email,
            role: 'portal_user',
            is_staff: false,
            impersonated_by: this.impersonatedBy
          },
          account: {
            id: this.appConfigService.tenant?.id,
            account_name: this.appConfigService.tenant?.name,
            account_subdomain: this.appConfigService.tenant?.subdomain
          }
        });
      }
      this.isInTestMode = this.appConfigService.tenant?.settings?.isTestModeEnabled === true;
    });
  }

  ngOnDestroy() {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    this._oidcSubscription?.unsubscribe();
  }

  onNavClick(sidenav) {
    if (this.mobileQuery.matches) sidenav.close();
  }
}
